









import { Component, Vue } from 'vue-property-decorator';
import ChevronDoubleRightIcon from 'vue-material-design-icons/ChevronDoubleRight.vue';
import RdStation from "@/plugins/api/RdStation";

@Component({
  components: { ChevronDoubleRightIcon },
})
export default class DetalhesProsseguir extends Vue {

  get cotacao() {
    return this.$store.state.cotacao;
  }

  get nextQuery() {
    const query = {} as { ref: string };
    if (this.cotacao.cod_indicador !== 0) {
      query.ref = this.cotacao.cod_indicador as string;
    }
    return query;
  }

  get nextUrl() {
    if (this.cotacao.valor_fipe > 100000) {
      return 'acima100';
    }
    return 'abaixo100';
  }

  public openWhatsApp() {
    let url = 'http://wa.me/554491056559?text=Ol%C3%A1,%20acabei%20de%20fazer%20minha%20simula%C3%A7%C3%A3o%20no%20site%20e%20quero%20mais%20informa%C3%A7%C3%B5es';

    if (this.$store.state.vendedor && this.$store.state.vendedor.link) {
      url = this.$store.state.vendedor.link;
    }

    window.open(url, '_blank');
    RdStation.conversion({
      'email': this.$store.getters.get_email,
      'identificador': 'Clicou em Whatsapp',
      'Clicou em Whatsapp': 'Sim',
      'id_proposta': this.cotacao.id,
      'id_vendedor': this.cotacao.vendedor ?? 16482,
    }).then();
  }

  public onClick() {
    const query = {} as { ref: string };

    if (this.cotacao.cod_indicador !== 0) {
      query.ref = this.cotacao.cod_indicador as string;
    }

    // O Lead já foi reportado quando o registro foi criado em DadosProsseguir;
    // aqui só sinalizamos o avanço de intenção de compra.
    window.fbq('track', 'AddToCart', {
      value: this.$store.getters.valor_mensalidade,
      currency: 'BRL',
    });

    this.openWhatsApp();
  }
}
